import { offlineConsultsTabs } from "./constants";

const Menu = ({ tab, history, totalRows }) => {
  const dashboard = offlineConsultsTabs;

  const changeTab = (route) => {
    history.push(route);
  }

  return (
    <div className="pb-10">
      <div className="table tabColor w-full text-sm">
        {dashboard.map((elem, index) => {
          return (
            <div
              key={elem.id}
              className={
                elem.id === tab
                  ? index === 0
                    ? "table-cell text-center bg-white rounded-tr-xl font-semibold"
                    : index === dashboard.length - 1
                    ? "table-cell text-center bg-white rounded-tl-xl font-semibold"
                    : "table-cell text-center bg-white rounded-t-xl font-semibold"
                  : "table-cell text-center"
              }
              onClick={() => changeTab(elem.route)}
            >
              <div className="px-2 py-4 text-gray-500 cursor-pointer">
                <span className="hover:text-gray-800">{elem.name}</span>
                {elem.id === tab && (
                  <span className="text-gray-100 font-semibold rounded-3xl p-1 bg-green-500 ml-2" style={{ fontSize: "10px" }}>
                    {totalRows > 9 ? totalRows : "0" + totalRows}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Menu;
